export const fileUpdate = 'file.update';
export const pageCreate = 'page.create';
export const pageUpdate = 'page.update';
export const pageDelete = 'page.delete';
export const pageMoveLeft = 'page.moveLeft';
export const pageMoveRight = 'page.moveRight';
export const fieldPositionCreate = 'fieldPosition.create';
export const fieldPositionUpdate = 'fieldPosition.update';
export const fieldPositionDelete = 'fieldPosition.delete';
export const fieldCreate = 'field.create';
export const fieldUpdate = 'field.update';
export const fieldDelete = 'field.delete';
export const fieldRowCreate = 'field.value.rowCreate';
export const fieldRowUpdate = 'field.value.rowUpdate';
export const fieldRowMove = 'field.value.rowMove';
export const fieldRowDelete = 'field.value.rowDelete';
export const fieldPositionFocus = 'fieldPosition.focus';
export const fieldPositionSelect = 'fieldPosition.select';
export const fieldPositionBlur = 'fieldPosition.blur';
export const pageFocus = 'page.focus';
export const pageBlur = 'page.blur';

export default {
  fileUpdate,
  pageCreate,
  pageUpdate,
  pageDelete,
  pageMoveLeft,
  pageMoveRight,
  fieldPositionCreate,
  fieldPositionUpdate,
  fieldPositionDelete,
  fieldCreate,
  fieldUpdate,
  fieldDelete,
  fieldRowCreate,
  fieldRowUpdate,
  fieldRowMove,
  fieldRowDelete,
  fieldPositionFocus,
  fieldPositionSelect,
  fieldPositionBlur,
  pageFocus,
  pageBlur,
};
